import { useState, useEffect } from 'react'
import { useClientStore } from '../../../../store/useClientStore'
import { toast } from 'react-toastify'
import ApiClient from '../../../api/client'

const apiClient = new ApiClient()

const UpdateClientModal = ({ onClose }) => {
  const {
    showUpdateModal,
    closeUpdateModal,
    editingClient,
    updateClient,
    clients,
  } = useClientStore()

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [program, setProgram] = useState([])
  const [programId, setProgramId] = useState('')
  const [image, setImage] = useState(null)
  const [status, setStatus] = useState('')
  const [statusOption, setStatusOption] = useState([])
  const [previewImage, setPreviewImage] = useState(null)

  const statuses = [
    { id: 1, name: 'pending' },
    { id: 2, name: 'approved' },
    { id: 3, name: 'underreview' },
    { id: 4, name: 'suspended' },
  ]

  useEffect(() => {
    if (editingClient) {
      setName(editingClient.client_name || '')
      setEmail(editingClient.email || '')
      setImage(null)
      setPreviewImage(editingClient.image || null)
      setProgramId(editingClient.program?.id || '')
      setStatus(editingClient.status || '')
    }
    setStatusOption(statuses)
    const fetchProgram = async () => {
      const { data, error } = await apiClient.fetchAllPrograms()
      if (data) {
        setProgram(data)
      }
    }
    fetchProgram()
  }, [editingClient])

  if (!showUpdateModal) return null

  const handleUpdate = async () => {
    await updateClient(editingClient.id, name, email, image, programId, status)
    onClose()
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg p-6 w-[80%] max-w-md shadow-xl">
        <div className="flex flex-col justify-center w-full">
          <h2 className="text-lg font-semibold mb-4">Update Client</h2>
          <div className="flex justify-center rounded-full pointer p-2 w-full">
            <img
              className="rounded-full pointer w-20 h-20"
              src={previewImage}
              alt=""
            />
          </div>
        </div>
        <input
          className="w-full border mb-2 p-2 rounded"
          type="text"
          value={name}
          name="name"
          onChange={(e) => setName(e.target.value)}
          placeholder="Name"
        />
        <input
          className="w-full border mb-2 p-2 rounded"
          type="text"
          value={email}
          name="email"
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
        />
        <input
          className="w-full border mb-2 p-2 rounded"
          type="file"
          name="image"
          accept="image/*"
          onChange={(e) => setImage(e.target.files[0])}
          placeholder="Email"
        />

        <select
          name="program"
          id="program"
          value={programId}
          className="w-full border mb-4 p-2 rounded"
          onChange={(e) => setProgramId(parseInt(e.target.value))}
          placeholder="Program"
        >
          <option value="">Select Program</option>
          {program.map((prog) => (
            <option key={prog.id} value={prog.id}>
              {prog.name}
            </option>
          ))}
        </select>

        <select
          name="status"
          id="status"
          value={status}
          className="w-full border mb-4 p-2 rounded"
          onChange={(e) => setStatus(e.target.value)}
          placeholder="Status"
        >
          <option value="">Select Status</option>
          {statusOption.map((e) => (
            <option key={e.id} value={e.name}>
              {e.name}
            </option>
          ))}
        </select>
        {/* <input
          className="w-full border mb-4 p-2 rounded"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          placeholder="Status"
        /> */}

        <div className="flex justify-end space-x-3">
          <button
            onClick={closeUpdateModal}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={handleUpdate}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  )
}

export default UpdateClientModal
